__turbopack_context__.v({
  "container": "PrizesSection-module__gi665W__container",
  "prizeCarouselContainer": "PrizesSection-module__gi665W__prizeCarouselContainer",
  "textMaxWidth": "PrizesSection-module__gi665W__textMaxWidth",
});
